export default "__VITE_ASSET__KIVU_ehS__"